import React from "react";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import { useTheme } from "context/ThemeContext";

export default function FixedPlugin(props: { [s: string]: any }) {
  const { ...rest } = props;
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      className="border-px fixed bottom-[30px] right-[35px] !z-[99] flex h-[60px] w-[60px] items-center justify-center rounded-full border-[#6a53ff] bg-gradient-to-br from-brandLinear to-blueSecondary p-0"
      onClick={toggleTheme}
      {...rest}
    >
      <div className="cursor-pointer text-ink">
        {isDark ? (
          <MdLightMode className="h-4 w-4 text-white" />
        ) : (
          <MdDarkMode className="h-4 w-4 text-white" />
        )}
      </div>
    </button>
  );
}
